import createReducer from 'shared/utils/createReducer';
import requestsStatuses from 'modules/common/constants/requestsStatuses';
import { LOGOUT } from 'modules/auth/actions/logout';
import { SEND_OTP_CODE } from 'modules/auth/actions/sendOtpCode';
import { EXTERNAL_LOGIN } from 'modules/auth/actions/externalLogin';

import {
  UPDATE_JWT_TOKEN,
  UPDATE_JWT_TOKEN_UNPOSSIBLE,
} from '../actions/updateJwtToken';

const defaultState = {
  requestStatus: requestsStatuses.default,
  value: undefined,
};


// TODO: we don't need this. Refactor modules/session/actions/updateJwtToken.js and then remove this reducer
export default createReducer(defaultState, {

  [SEND_OTP_CODE.success]: (state, { payload: { jwtToken } }) => ({
    ...state,
    value: jwtToken,
  }),

  [UPDATE_JWT_TOKEN.failure]: () => ({
    ...defaultState,
    requestStatus: requestsStatuses.failure,
  }),

  [UPDATE_JWT_TOKEN.pending]: (state) => ({
    ...state,
    requestStatus: requestsStatuses.pending,
  }),

  [UPDATE_JWT_TOKEN.success]: (state, { payload: { jwtToken } }) => ({
    ...state,
    requestStatus: requestsStatuses.success,
    value: jwtToken,
  }),

  [EXTERNAL_LOGIN.success]: (state, { payload: { jwtToken } }) => ({
    ...state,
    requestStatus: requestsStatuses.success,
    value: jwtToken,
  }),

  [UPDATE_JWT_TOKEN_UNPOSSIBLE]: () => ({
    ...defaultState,
  }),

  [LOGOUT.failure]: () => defaultState,
  [LOGOUT.success]: () => defaultState,
});
